import axios from '../shared/axios';
import * as events from './events';

export function createInstructionToQuote(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/InstructionToQuote/Create`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function updateInstructionToQuote(data) {
    return new Promise((resolve, reject) => {
        axios.put(`/api/InstructionToQuote/Update`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function getInstructionToQuote(instructiontoquoteid) {
    return axios.get(`/api/InstructionToQuote/GetInstructionToQuote?instructiontoquoteid=${instructiontoquoteid}`);
}

export function getContractInstructionToQuotes(companyid, projectid, contractid, accessibleWfIds) {
    return axios.post(`/api/InstructionToQuote/LoadInstructionToQuotesList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}&startdate=&enddate=&accessibleWfIds=${accessibleWfIds}`);
}

export function getInstructionToQuotes(companyid, projectid, contractid, accessibleWfIds) {
    return axios.post(`/api/InstructionToQuote/RegisterList`, { accessibleWfIds }, { params: { companyid, projectid, contractid } });
}

export function deleteInstructionToQuoteDraft(instructiontoquoteid) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/InstructionToQuote/DeleteDraft?instructiontoquoteid=${instructiontoquoteid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}

export function importITQs(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/InstructionToQuote/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteITQDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/InstructionToQuote/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateITQDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/InstructionToQuote/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}